<template>
  <canvas ref="canvas" id="starfield"></canvas>
</template>

<script>
import StarFieldRenderer from '@/utils/StarFieldRenderer';
import { loadConfiguration, parseConfiguration, getDefaultConfigurations } from '@/utils/starfieldConfig';
import { ref, onMounted } from 'vue';

export default {
  name: 'StarField',
  emits: ['loaded'],
  setup(props, { emit }) {
    const canvas = ref(null);
    const starField = ref(null);
    
    const initializeStarField = async () => {
      try {
        // Try to load configuration from file
        const configPath = '/config/starfield-config.json';
        const loadedConfig = await loadConfiguration(configPath);
        const parsedConfig = parseConfiguration(loadedConfig);
        
        // Use loaded config or fall back to defaults
        const defaultConfig = getDefaultConfigurations();
        const starLayerConfigs = parsedConfig?.starLayerConfigs || defaultConfig.starLayerConfigs;
        const gradientConfig = parsedConfig?.gradientConfig || defaultConfig.gradientConfig;
        const settings = parsedConfig?.settings || defaultConfig.settings;
        
        // Initialize the starfield with our configurations
        starField.value = new StarFieldRenderer(canvas.value, starLayerConfigs, gradientConfig, settings);
        
        // Let parent know starfield is loaded
        emit('loaded');
      } catch (error) {
        console.error('Failed to initialize starfield:', error);
        // Even on error, emit loaded to ensure background fades out
        emit('loaded');
      }
    };

    onMounted(() => {
      // Defer starfield initialization until after content is rendered
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          initializeStarField();
        }, { timeout: 2000 });
      } else {
        setTimeout(initializeStarField, 100);
      }
    });

    return {
      canvas
    };
  }
}
</script>

<style scoped>
#starfield {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
}
</style>
